import { TFunction } from 'next-i18next'

export const joinSessionMessage = (t: TFunction): string => {
  return t('joinSession', { ns: 'fixtureMessage' }).replace(/{{link}}/g, '%LINK%')
}
